<template>
  <div class="page">
    <div class="container">
      <div class="row">
        <div class="col">
          <div class="locations-grey locations-generic contact">
            <section>
              <router-link to="/Sample">
                <hr />
                <h1>
                  Previous Projects
                  <a href="#/" class="logo-link">
                    <img src="../assets/logo.svg" id="logo" alt="logo" />
                  </a>
                </h1>
                <hr />
              </router-link>
              <h3>
                <a href="http://www.AmericanEnergyConsulting.com"
                  >AmericanEnergyConsulting.com</a
                >
              </h3>
              <h3>
                <a href="http://www.Chicago-Artwork.com"
                  >Chicago-Artwork.com</a
                >
              </h3>
              <h3>
                <a href="http://www.ChicagoRiverPaddle.com"
                  >ChicagoRiverPaddle.com</a
                >
              </h3>
              <h3>
                <a href="http://www.Artist-ERJ.com">Artist-ERJ.com</a>
              </h3>
              <h3>
                <a href="http://www.ImejTech.com">IMEJTech.com</a>
              </h3>
            </section>
            <router-link to="/Contact">
              <hr />
              <h1>
                Let's make your Vision a Reality
                <a href="#/" class="logo-link">
                  <img src="../assets/logo.svg" id="logo" alt="logo" />
                </a>
              </h1>
            </router-link>
            <a href="mailto:Eric@ImejTech.com">
              <i class="far fa-envelope"
                >Eric@ImejTech.com
                <a href="#/" class="logo-link">
                  <img src="../assets/logo.svg" id="logo" alt="logo" />
                </a>
              </i>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Portfolio",
  components: {},
};
</script>

<style scoped>
#logo {
  height: 20px;
  padding-left: 0px;
}
hr {
  background-color: grey;
}
.page {
  background-image: url("../assets/screen-5.png");
  background-size: cover;
  background-position: center;
  animation: backgroundMove 120s ease-in-out infinite;
}
h1 {
  color: white;
}
h3 {
  color: white !important;
}
.col {
  background-color: #232f3e;
  background-image: url("https://www.transparenttextures.com/patterns/black-orchid.png");
}
.section {
  background-color: #007bff;
}

@keyframes backgroundMove {
  0% {
    background-position: 0% 0%;
  }
  50% {
    background-position: 100% 100%;
  }
  100% {
    background-position: 0% 0%;
  }
}
</style>
